var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.698 7.62H11.918L14.658 4.8C11.928 2.1 7.508 2 4.778 4.7C4.1294 5.34059 3.61443 6.10358 3.26296 6.94471C2.91149 7.78584 2.7305 8.68839 2.7305 9.6C2.7305 10.5116 2.91149 11.4142 3.26296 12.2553C3.61443 13.0964 4.1294 13.8594 4.778 14.5C7.508 17.2 11.928 17.2 14.658 14.5C16.018 13.15 16.698 11.58 16.698 9.6H18.698C18.698 11.58 17.818 14.15 16.058 15.89C12.548 19.37 6.848 19.37 3.338 15.89C-0.161998 12.42 -0.191998 6.78 3.318 3.31C5.00091 1.64275 7.27405 0.707398 9.643 0.707398C12.012 0.707398 14.2851 1.64275 15.968 3.31L18.698 0.5V7.62Z",
    fill: "#BBBBF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRoundIcon);
export default __webpack_public_path__ + "static/media/ArrowRoundIcon.6618a3fbb6ba1a37e1f90cd5ea9e0e04.svg";
export { ForwardRef as ReactComponent };